import classNames from 'classnames';
import { ReactNode } from 'react';
import { useEnv } from 'src/hooks';
import { useSidebarState } from '../../hooks';
import styles from '../Sidebar.module.css';

type SidebarWrapperType = { children: ReactNode };

const SidebarWrapper = ({ children }: SidebarWrapperType) => {
  const { isSidebarCollapsed, setIsHover } = useSidebarState();
  const { isProdEnv } = useEnv();

  return (
    <div className={styles.sidebarContainer}>
      <div
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
        className={classNames(styles.sidebar, styles.sidebarDefault, {
          [styles.staging]: !isProdEnv,
          [styles.sidebarCollapsed]: isSidebarCollapsed,
        })}
      >
        {children}
      </div>
    </div>
  );
};

export default SidebarWrapper;
